var _excluded = ["minHeight", "maxHeight"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { Box, Icon, Flex, Text } from "../..";
import InputLabel from "./InputLabel";
import { isEmpty } from "../../../helpers/data";
import { _getContainerStyles, ColorStates } from "./InlineField.styles";

var InlineField = function InlineField(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      label = _ref.label,
      icon = _ref.icon,
      isInputFocused = _ref.isInputFocused,
      value = _ref.value,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      error = _ref.error,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      validated = _ref.validated,
      helperText = _ref.helperText,
      fullWidth = _ref.fullWidth,
      children = _ref.children;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isHovered = _React$useState2[0],
      setIsHovered = _React$useState2[1];

  var isInputFilled = !isEmpty(value);
  var onHover = React.useCallback(function () {
    setIsHovered(true);
  }, []);
  var onHoverout = React.useCallback(function () {
    setIsHovered(false);
  }, []);

  var _getContainerStyles2 = _getContainerStyles({
    isFocused: isInputFocused,
    isHovered: isHovered,
    disabled: disabled,
    error: error,
    validated: validated,
    fullWidth: fullWidth
  }),
      containerHeight = _getContainerStyles2.minHeight,
      containerMaxHeight = _getContainerStyles2.maxHeight,
      containerStyles = _objectWithoutProperties(_getContainerStyles2, _excluded);

  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: disabled ? 'grey.100' : 'white',
    onMouseOver: onHover,
    onMouseOut: onHoverout,
    sx: containerStyles
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    px: 3
  }, /*#__PURE__*/React.createElement(Icon, {
    size: "medium",
    icon: icon,
    color: disabled ? 'grey.400' : 'grey.600',
    pr: 2
  }), /*#__PURE__*/React.createElement(Flex, {
    flexGrow: 1,
    minHeight: containerHeight,
    maxHeight: containerMaxHeight
  }, /*#__PURE__*/React.createElement(InputLabel, {
    label: label,
    size: size,
    disabled: disabled,
    isInputFocused: isInputFocused,
    isInputHovered: isHovered,
    isInputFilled: isInputFilled,
    required: required
  }), /*#__PURE__*/React.createElement(Flex, {
    flexGrow: 1,
    alignItems: "stretch"
  }, children)))), helperText ? /*#__PURE__*/React.createElement(Text, {
    color: error ? ColorStates.ERROR : validated ? ColorStates.VALIDATED : ColorStates.DEFAULT,
    fontSize: 1,
    pt: 1
  }, helperText) : null);
};

export { InlineField };
export default InlineField;